import React, { useEffect } from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Recruitment from "./pages/Recruitment";
import Company from "./pages/Company";
import Contact from "./pages/Contact";
import News from "./pages/News";
import Layout from "./components/Layout";
import GlobalStyle from "./styles/GlobalStyle";
import AOS from "aos";
import "aos/dist/aos.css";

// スクロール位置をトップに戻すコンポーネント
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      mirror: true,
      offset: 120,
    });

    // ページ全体のロード後にAOSを再計算してスクロール高さを正しく認識させる
    const handleLoad = () => {
      AOS.refresh();
    };
    window.addEventListener("load", handleLoad);

    // ページリロード時にスクロール位置をトップに戻す
    window.onbeforeunload = () => {
      window.scrollTo(0, 0);
    };

    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  return (
    <Router>
      <GlobalStyle />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/recruitment" element={<Recruitment />} />
        <Route path="/company" element={<Company />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/news" element={<News />} />
        <Route
          path="*"
          element={
            <Layout>
              <h1>404 - ページが見つかりません</h1>
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
